import {getRestApi} from './ApiAxios'

export const ObtenerTarifarioPorEmpresaId = async (idEmpresa) => {
  const restApi = await getRestApi()
  return await restApi.get(
    'tarifario-function/ObtenerTarifarioPorEmpresa?empresaId=' + idEmpresa
  )
}
